import {AfterViewInit, Component, ElementRef, Input, ViewChild} from '@angular/core';
import {NavigationService} from '../../services/navigation/navigation.service';
import {PageNames} from '../page-names.enum';
import {SelectableNavigationItem} from '../../model/selectable-navigation-item';
import {TvShopStateService} from '../../services/state/tv-shop-state.service';

@Component({
  selector: 'app-arrow',
  templateUrl: './arrow.component.html',
  styleUrls: ['./arrow.component.less']
})
export class ArrowComponent extends SelectableNavigationItem implements AfterViewInit {
  pointsDown = true;
  @Input()  ownerComponent: string;
  showArrow = true;
  @ViewChild('arrowdown', {read: ElementRef})
  arrowDownElement: ElementRef;

  constructor(private navigationService: NavigationService,
              private stateService: TvShopStateService) {
    super();
  }

  ngAfterViewInit(): void {
    this.navigationService.registerNavigation(this, PageNames.ARROW_DIRECTION);
    this.stateService.isTrailerPlaying$.subscribe( (trailerPlaying) => {
      this.showArrow = !trailerPlaying;
    });
  }


  onEnter(): void {
    this.onBack();
  }

  onBack(): void {
    this.navigationService.resetPage();
  }

}
